import React from "react";

// GT designed empty state: a Cormorant line + one quiet sub-line in voice.
// Never a blank void or a raw "No data".
export default function EmptyState({ line, sub, icon = null, testId = "empty-state", compact = false }) {
  return (
    <div
      data-testid={testId}
      className="flex flex-col items-center justify-center text-center"
      style={{ padding: compact ? "28px 20px" : "56px 24px" }}
    >
      {icon ? <div style={{ marginBottom: 14, opacity: 0.5, color: "#B0905E" }}>{icon}</div> : null}
      <div style={{ fontFamily: "Cormorant, 'Cormorant Garamond', serif", fontSize: 24, lineHeight: 1.2, color: "#231E1A" }}>
        {line}
      </div>
      {sub ? (
        <div style={{ marginTop: 8, fontSize: 14, color: "#8A7355", maxWidth: 340, lineHeight: 1.5 }}>{sub}</div>
      ) : null}
    </div>
  );
}
